import React from 'react';
import { Route, Router,Switch } from 'react-router-dom';
import { LocalizeProvider } from "react-localize-redux";
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk';
import { Provider } from 'react-redux'
import { routerMiddleware } from 'react-router-redux';
import Auth from '../components/Auth/auth';
import reducer from '../reducers'
import history from '../routes/history';
import LandingPage from '../components/HomePage/LandingPage';
import JobProviderHome from '../components/JobProvider/Home';
import SignUp from '../components/SignUp/SignUp';
import ManuelSignUp from '../components/SignUp/ManuelSignUp';
import ForgotPassword from '../components/SignUp/ForgotPassword';
import SignIn from '../components/SignIn/SignIn';
import JobProviderProfile from '../components/JobProvider/Profile/JobProviderProfile';
import JobSeekerProfile from '../components/JobSeekers/Profile/JobSeekerProfile';
import TermsAndCondition from '../components/Inc/InfoPage/TermsAndCondition';
import ContactUs from '../components/Inc/InfoPage/ContactUs';
import PrivecyPolicy from '../components/Inc/InfoPage/PrivacyPolicy';
import Sitemap from '../components/Inc/InfoPage/Sitemap';
import AboutUs from '../components/Inc/InfoPage/AboutUs';
import HowItWorks from '../components/Inc/InfoPage/HowItWorks';
import RedirectToCity from '../components/RedirectToCity';
import SearchResult from '../components/Search/FindCompany';
import SearchJob from '../components/Search/FindJobs';
import SearchJobCompanyDetails from '../components/Search/SearchJobCompanyDetail';
import JobCompanyDetails from '../components/Search/JobCompanyDetails';
import JobEdit from '../components/Job/JobEdit';
import Chat from '../components/Chat/Chat.js';
import Blog from '../components/Blog/Blog.js';
import BlogSingle from '../components/Blog/Blogsingle.js';
import SubUserSignUp from '../components/SignUp/SubUserSignUp';

const historyMiddleware = routerMiddleware(history);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const auth = new Auth();



export const store = createStore(
    reducer,
    composeEnhancers(
        applyMiddleware(historyMiddleware, thunk)
    )
)



export const makeMainRoutes = () => {
    return (
        <Provider store={store}>
            <Router history={history} > 
                    <LocalizeProvider> 
                        <Switch>                
                            <Route  path="/about-uss" render={(props) => <AboutUs  {...props} />}  />
                            
                            <Route exact path="/dashboard-home" render={(props) => <JobProviderHome auth={auth}   {...props} />}/>
                            
                            <Route exact path="/company-reqruiter" render={(props) => <JobProviderHome auth={auth}   {...props} />}/>
                            
                            <Route exact path="/account-detail" render={(props) =><JobProviderProfile auth={auth}  {...props} />} />

                            <Route exact path="/user-profile" render={(props) =><JobSeekerProfile auth={auth}  {...props} />} />
                            
                            <Route exact path="/edit-job" render={(props) =><JobEdit auth={auth}  {...props} />} />
                            
                            <Route exact path="/blog" render={(props) =><Blog auth={auth}  {...props} />} />

                            <Route exact path="/blog-view/:title" render={(props) =><BlogSingle auth={auth}  {...props} />} />
                            
                            <Route exact path="/home" render={(props) => <LandingPage auth={auth} {...props} />}/>                 
                            
                            <Route exact path="/sign-up" render={(props) => <SignUp  auth={auth} {...props} />} />                 
                            
                            <Route exact path="/signUp" render={(props) => <ManuelSignUp  auth={auth} {...props} />} />                 
                            
                            <Route exact path="/forgotPassword" render={(props) => <ForgotPassword  auth={auth} {...props} />} />                 

                            <Route exact path="/sub-user-verify" render={(props) => <SubUserSignUp  auth={auth} {...props} />} />                 
                            
                            <Route exact path="/sign-in" render={(props) => <SignIn auth={auth} {...props} />} />                 
                            
                            <Route exact path="/search-result" render={(props) => <SearchResult auth={auth} {...props} />}/>                 
                            
                            <Route exact path="/search-jobs" render={(props) => <SearchJob auth={auth} {...props} />}/>                 
                            
                            <Route exact path="/about-us" render={(props) => <AboutUs  {...props} />}  />                  
                            
                            <Route exact path="/howItWorks" render={(props) => <HowItWorks  {...props} />}  />                  
                            
                            <Route exact path="/privecy-policy" render={(props) => <PrivecyPolicy  {...props} />}  />                  
                            
                            <Route exact path="/terms-condition" render={(props) => <TermsAndCondition  {...props} />}  />                  
                            
                            <Route exact path="/sitemap" render={(props) => <Sitemap  {...props} />}  />     
                            
                            <Route exact path="/contact-us" render={(props) => <ContactUs  {...props} />}  />     
                            
                            <Route exact path="/message" render={(props) => <Chat  {...props} />}  />     
                            

                            <Route exact path="/:city" render={(props) => <LandingPage auth={auth} {...props} />}/>
                            
                            <Route exact path="/home/:city" render={(props) => <LandingPage auth={auth} {...props} />}/>                 
                            
                            <Route exact path="/search-result/:city" render={(props) => <SearchResult auth={auth} {...props} />}/>                 
                            
                            <Route exact path="/search-jobs/:city" render={(props) => <SearchJob auth={auth} {...props} />}/>                  
                            
                            <Route exact path="/user-profile/:city" render={(props) =><JobSeekerProfile auth={auth}  {...props} />} />
                            
                            <Route exact path="/account-detail/:city" render={(props) =><JobProviderProfile auth={auth}  {...props} />} />
                            
                            <Route exact path="/blog/:city" render={(props) =><Blog auth={auth}  {...props} />} />
                            
                           /*Old ROutes*/
                            <Route exact path="/search-job-details" render={(props) => <SearchJobCompanyDetails  {...props} />}  />     
                            <Route exact path="/search-job-details/:recruterId" render={(props) =><SearchJobCompanyDetails auth={auth}  {...props} />} />
                            <Route exact path="/search-job-details/:recruterId/:city" render={(props) =><SearchJobCompanyDetails auth={auth}  {...props} />} />
                          
                           /*New Rutes*/
                            <Route exact path="/profile" render={(props) => <SearchJobCompanyDetails  {...props} />}  />     
                            <Route exact path="/profile/:recruterId" render={(props) =><SearchJobCompanyDetails auth={auth}  {...props} />} />
                            <Route exact path="/profile/:recruterId/:city" render={(props) =><SearchJobCompanyDetails auth={auth}  {...props} />} />
                            
                            <Route exact path="/:recruterId/job/:jobId/" render={(props) =><JobCompanyDetails auth={auth}  {...props} />} />
                            <Route exact path="/:recruterId/job/:jobId/:city" render={(props) =><JobCompanyDetails auth={auth}  {...props} />} />

                            <Route exact path="/" render={(props) => <RedirectToCity auth={auth}   {...props} />}/>                            
                        </Switch>
                    </LocalizeProvider>
            </Router>
        </Provider>
    );
}


// WEBPACK FOOTER //
// ./src/routes/routes.js